// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P2zq","colMin":"styles_colMin__2W6Ur"};